import {observer} from "mobx-react";
import IconBurger from "./icon-burger";
import Icon from "../../../../icons/icon/icon";
import appLayoutStore from "../../../../../stores/app-layout-store";
import "./sidebar-burger-menu.scss";

const SidebarBurgerMenu = observer(() => {
    const { floating, interactions } = appLayoutStore.sidebarSettings;

    if (!appLayoutStore.showFloatingSidebar) {
        return null;
    }

    return (
        <button
            className="sidebar-burger-menu"
            ref={floating?.refs.setReference}
            {...interactions?.getReferenceProps()}
            aria-label="Open sidebar"
            onClick={() => {
                appLayoutStore.isSidebarOpen = !appLayoutStore.isSidebarOpen;
            }}
        >
            <Icon Component={IconBurger} />
        </button>
    );
});

export default SidebarBurgerMenu;